import  React  from "react";
import { Link } from 'react-router-dom';
import { UserContext } from "../contexts/UserContext";
import UserContextProvider from "../contexts/UserContext";
import { userService } from "../services/UserService";
import SubscriptionPageForm from "../components/SubscriptionPageForm";

const SuccessfulPayment = () => {

    const { userState, dispatch } = React.useContext(UserContext);

    React.useEffect(() => {

        userService.successfulPayment(dispatch)

    }, [dispatch]);


    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-200">
            <h1 className="text-2xl font-bold mb-4 text-green-500">Subscription Successful!</h1>
            <p className="text-center mb-4">
                Thank you for subscribing to our service. Your subscription is now active.
            </p>
            <p className="text-center mb-4">
                You can now enjoy all the premium features and benefits for the duration of your subscription.
            </p>
            <Link to="/#/" className="text-blue-500">
                Go to Dashboard
            </Link>
        </div>
    );
}

export default SuccessfulPayment;